import { util } from "../../../../lib/util/util";
import { SettingsNormalization } from "../../../../lib/util/SettingsNormalization";
import { Alt1Color } from "../../../../lib/alt1/Alt1Color";
export var ScanSolving;
(function (ScanSolving) {
    let Settings;
    (function (Settings) {
        var compose = util.compose;
        Settings.normalize = SettingsNormalization.normaliz({
            show_minimap_overlay_scantree: SettingsNormalization.bool(true),
            show_minimap_overlay_simple: SettingsNormalization.bool(true),
            minimap_overlay_automated_zoom_detection: SettingsNormalization.bool(false),
            minimap_overlay_zoom_manual_ppt: compose(SettingsNormalization.number(4), SettingsNormalization.clamp(3, 30)),
            show_double_ping: SettingsNormalization.bool(true),
            show_triple_ping: SettingsNormalization.bool(true),
            zoom_behaviour_include_triples: SettingsNormalization.bool(false),
            zoom_behaviour_include_doubles: SettingsNormalization.bool(false),
            zoom_behaviour_include_singles: SettingsNormalization.bool(false),
            select_floor_based_on_previous_solution: SettingsNormalization.bool(true),
            input_control_enabled: SettingsNormalization.bool(true),
            input_control_configuration: SettingsNormalization.normaliz({
                position: SettingsNormalization.normaliz({
                    x: compose(SettingsNormalization.number(0), SettingsNormalization.clamp(-2000, 2000)),
                    y: compose(SettingsNormalization.number(0), SettingsNormalization.clamp(0, 2000))
                }),
                size: SettingsNormalization.normaliz({
                    x: compose(SettingsNormalization.number(160), SettingsNormalization.clamp(160, 1000)),
                    y: compose(SettingsNormalization.number(100), SettingsNormalization.clamp(100, 1000))
                }),
                gutter: compose(SettingsNormalization.number(5), SettingsNormalization.clamp(1, 20)),
                warn_for_meerkats: SettingsNormalization.bool(true),
                show_help_button: SettingsNormalization.bool(true),
                force_small_back_button: SettingsNormalization.bool(false),
            }),
            panel_status_overlay_enabled: SettingsNormalization.bool(true),
            panel_status_overlay_configuration: SettingsNormalization.normaliz({}),
        });
    })(Settings = ScanSolving.Settings || (ScanSolving.Settings = {}));
    let PulseColors;
    (function (PulseColors) {
        PulseColors.different_level = Alt1Color.fromHex("#8adc13");
        PulseColors.triple = Alt1Color.fromHex("#d51918");
        PulseColors.double = Alt1Color.fromHex("#e1a53f");
        PulseColors.single = Alt1Color.fromHex("#0f91d3");
        const pulsecolors = [
            PulseColors.different_level, // 0 is special for "different level"
            PulseColors.single, PulseColors.double, PulseColors.triple
        ];
        function forContextPulse(pulse) {
            return pulse.type ? pulsecolors[pulse.type] : pulsecolors[pulse.text == "DL" ? 0 : 1];
        }
        PulseColors.forContextPulse = forContextPulse;
        function forPulse(pulse) {
            return pulsecolors[pulse.pulse];
        }
        PulseColors.forPulse = forPulse;
    })(PulseColors = ScanSolving.PulseColors || (ScanSolving.PulseColors = {}));
})(ScanSolving || (ScanSolving = {}));
